import { useTranslation } from 'react-i18next';

export default function SocialDeliveryError({ error }) {
  const { t } = useTranslation();
  if (!error) return null;
  const key = `channel_delivery_${error.category || 'provider_rejected'}`;
  return <div role="alert" className="unassigned-badge" style={{ padding: '10px 14px', whiteSpace: 'normal' }}>
    {t(key, { defaultValue: error.message || t('channel_delivery_provider_rejected') })}
  </div>;
}
